// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eMkB","left":"styles_left__1VWKk","desktopActions":"styles_desktopActions__2vDRW","title":"styles_title__HsD36"};